<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                        <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>
                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                        <p>
                            Vista para revisar existencias actuales.
                            Muestra cuánto hay disponible por planta/almacén 
                            y producto. Úsalo antes de vender o mover mercadería 
                            para evitar faltantes.
                        </p>
                        </div>
                    </mat-menu>
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        Stock
                    </h2>
                </div>
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Monitorea la información actual de <b>stock</b> dentro de AVE.
                </div>
            </div>
            <!-- Header -->
            <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex shrink-0">
                    <!-- Title -->
                    <!--<div class="text-3xl font-extrabold tracking-tight">Stock al Momento</div> -->
                </div>
                <!-- Actions -->
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                    <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
                        (click)="openExportSidenav()" matTooltip="Exportar">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                        <span class="ml-2">Exportar</span>
                    </button>
                    <div style="display:inline-flex">
                        <button mat-icon-button [matMenuTriggerFor]="importMenu" matTooltip="Importar archivo">
                            <mat-icon>
                                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0,0,256,256">
                                    <g fill="#4f46e5" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                                        stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                                        font-family="none" font-weight="none" font-size="none" text-anchor="none"
                                        style="mix-blend-mode: normal">
                                        <g transform="scale(5.12,5.12)">
                                            <path
                                                d="M30,26v9h-4.18c0.12,-0.38 0.18,-0.78 0.18,-1.2v-7.8zM30,37v9h-13c-1.65,0 -3,-1.35 -3,-3v-5h7.8c1.03,0 1.98,-0.37 2.71,-1zM32,26h16v9h-16zM32,37h16v6c0,1.65 -1.35,3 -3,3h-13zM30,15v9h-4v-7.8c0,-0.42 -0.06,-0.82 -0.18,-1.2zM32,15h16v9h-16zM30,4v9h-5.49c-0.73,-0.63 -1.68,-1 -2.71,-1h-7.8v-5c0,-1.65 1.35,-3 3,-3zM48,7v6h-16v-9h13c1.65,0 3,1.35 3,3zM21.8,36h-17.6c-1.215,0 -2.2,-0.985 -2.2,-2.2v-17.6c0,-1.215 0.985,-2.2 2.2,-2.2h17.6c1.215,0 2.2,0.985 2.2,2.2v17.6c0,1.215 -0.985,2.2 -2.2,2.2zM7.968,19l3.494,5.978l-3.831,6.022h2.863l2.521,-4.716l2.533,4.716h2.821l-3.769,-6l3.685,-6h-2.675l-2.455,4.505l-2.323,-4.505z">
                                            </path>
                                        </g>
                                    </g>
                                </svg>
                            </mat-icon>
                        </button>
                        <mat-menu #importMenu="matMenu">
                            <button mat-menu-item (click)="downloadStockTemplate()">
                                <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
                                <span>Descargar Plantilla</span>
                            </button>
                            <input #my_file style="display: none" type="file" (change)="handleFileInput($event)" accept=".xlsx"
                                #hiddenfileinput>
                            <button mat-menu-item (click)="hiddenfileinput.click()">
                                <mat-icon svgIcon="heroicons_outline:arrow-up-tray"></mat-icon>
                                <span>Importar Archivo</span>
                            </button>
                        </mat-menu>
                        <button mat-raised-button style="margin-right: 8px;" type="button" *ngIf="aux_file"
                            [disabled]="this.fileToUpload.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                            color="primary" (click)="onMessageConfirm()">
                            Importar archivo
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
            <!-- Main Content (Table and Paginator) -->
            <div class="pt-1 mx-6">
                <!-- Tabla -->
                <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
                    <!-- Header -->
                    <div class="overflow-auto flex-1 dark:bg-gray-900">
                        <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
                            (matSortChange)="changeSort($event)">

                            <ng-container matColumnDef="flag">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <mat-icon
                                        style="margin-left: 0.5em; float:left; font-size: 16px; color: rgb(9, 133, 50)"
                                        matTooltip="Cumple Atención">check</mat-icon>
                                    <mat-icon
                                        style="margin-left: 0.5em; float:left; font-size: 16px; color: rgb(141, 19, 19)"
                                        matTooltip="No cumple Atención">close</mat-icon>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="materialId">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Material</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        <b class="f-10" *ngIf="getCode(element.materialDetails) as code">
                                            {{ code }} <br>
                                        </b>
                                        <span class="font-descrip uppercase"> {{element.materialDetails?.name}}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="warehouseId">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Almacén</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        <b class="f-10" *ngIf="getCode(element.warehouseDetails) as code">
                                            {{ code }} <br>
                                        </b>
                                        <span class="font-descrip"> {{element.warehouseDetails?.name}}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="unitOfMeasureId">
                                <th mat-header-cell *matHeaderCellDef class="table-title">UM</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        <b class="f-10" *ngIf="getCode(element.unitOfMeasureDetails) as code">
                                            {{ code }} <br>
                                        </b>
                                        <span class="font-descrip"> {{element.unitOfMeasureDetails?.name}}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="lot">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Lote</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.lot}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="lotExpirationDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Fecha <br>
                                    Vto. Lote</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.lotExpirationDate | FormatDateHour: false }}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="availableStock">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title text-right"
                                    arrowPosition="before">Cantidad</th>
                                <td mat-cell *matCellDef="let element" class="table-text text-right">
                                    <div class="text-content">
                                        {{element.availableStock | number: '1.2-2'}}
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Header Row -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"
                                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
                        </table>
                    </div>
                    <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo
                        sentimos, no hay registros para mostrar.
                    </div>
                </div>

                <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
                    <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
                        [length]="totalItems" [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
                </div>
            </div>
        </div>
    </div>

    <!-- Filtros -->
    <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">
        <app-filter-section title="Rango de fechas" [expanded]="true">
            <app-dates-filters [form]="form" [showDueDateRange]="true" />
        </app-filter-section>

        <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
            <app-configuration-filters [form]="form"[warehouseWithMongoId]="true" [loadData]="loadConfigData">
            </app-configuration-filters>
        </app-filter-section>

        <app-filter-section title="Gestión de Materiales"
            [expanded]="false" (onExpanded)="onMaterialsExpanded()">
            <app-materials-management-filters [form]="form"
                [materialWithMongoId]="true" [loadData]="loadMaterialsData"/>
        </app-filter-section>
    </app-filter>
</mat-sidenav-container>